(function () {

  'use strict';

  angular.module('eclipseApp.components')

    .directive('uteEnhancePopover', ['$compile', '$timeout', '$document', 'utePopoverFactory', function ($compile, $timeout, $document, utePopoverFactory) {

              return {
                restrict: 'EA',
                scope: {
                  popoverContent: '@',
                  popoverBackdrop: '=',
                  popoverClass: '@',
                  popoverTarget: '@',
                  popoverCloseTarget: '@',
                  popoverPlacement: '@',
                  popoverRemoveSelf: '=',
                  popoverInsertMode: '@',
                  popoverArrowPadding: '@',
                  popoverIcon: '@'
                },
                controller: ['$scope', '$element', function ($scope, $element) {

                  /**
                   * @memberOf ute-ui.content
                   * @type {object}
                   * @property {string} popoverContent
                   * @property {boolean} popoverBackdrop
                   * @property {string} popoverClass
                   * @property {string} popoverTarget
                   * @property {string} popoverCloseTarget
                   * @property {string} popoverPlacement
                   * @property {boolean} popoverRemoveSelf
                   * @property {string} popoverInsertMode
                   * @property {boolean} popoverArrowPadding
                   */

                  /**
                   * how insert the content into the target div
                   * @options - replace | append | after
                   * @default replace
                   * @type {string}
                   */
                  var popoverInsertMode = $scope.popoverInsertMode || 'append';

                  /**
                   * popoverClass
                   * @type {string}
                   */
                  $scope.popoverClass = $scope.popoverClass || '';

                  /**
                   * the offset of the arrow when position popover over target
                   * @default true
                   * @type {number}
                   */
                  $scope.popoverArrowPadding = $scope.popoverArrowPadding || 10;

                  /**
                   * options for popoverPlacement
                   * @type {string}
                   */
                  $scope.popoverPlacement = $scope.popoverPlacement || 'bottom';


                  /**
                   * displays the tooltip
                   */
                  $scope.show = function () {

                    if (!disabled) {

                      // if another popover is open, then close it
                      if ($document.find('popover.active')) {
                        $document.find('popover.active').removeClass('active');
                      }
                      if(angular.isDefined($scope.popoverIcon)){
                        var infoClass = '.' + $scope.popoverIcon;
                        if($document.find(infoClass)){
                          $document.find(infoClass).html('<img src="/html-fido/cms/ute/fido/images/brand/fido/info-icon-half.png" alt="info-tool-tip"/>');
                        }
                      }

                      $element.on('click', $scope.hide);

                      showToggle = true;

                      if (angular.isDefined($scope.popoverTarget) && (popoverRemoveSelf || firstTimeOpen)) {

                        $target = $($scope.popoverTarget);

                      } else if (!angular.isDefined($scope.popoverTarget) && (popoverRemoveSelf || firstTimeOpen)) {

                        $target = $($element);

                      }

                      ////////////////////////////////////////

                      firstTimeOpen = false;

                      insertPopoverContent();

                      // if popoverCloseTarget is defined then only use that element to close the popover
                      if (angular.isDefined($scope.popoverCloseTarget)) {
                        $scope.$closeTarget = $($scope.popoverCloseTarget);
                        $scope.$closeTarget.on('click', $scope.hide);
                      }

                      // if popover backdrop is defined
                      if (popoverBackdrop) {

                        // if not in DOM then add to DOM
                        if (!$('#backdrop').length) {
                          if (angular.isDefined($scope.popoverTarget)) {
                            $scope.popoverTarget.parent().after(backDrop);
                          } else {
                            $element.parent().after(backDrop);
                          }
                        }

                        // find backdrop by id
                        $backDrop = $backDrop || $('#backdrop');
                        $backDrop.addClass('active');
                        $backDrop.css({
                          zIndex: 10
                        });
                        // if popover close target is defined then hide on bg click
                        // !angular.isDefined($scope.popoverCloseTarget) && $backDrop.one('click', $scope.hide);
                        $backDrop.one('click', $scope.hide);

                      }

                      $target.css({
                        position: 'relative',
                        zIndex: 201
                      });

                      positionPopover(placement, $content, $target);

                      ////////////////////////////////////////


                      // makes it visible via css
                      $content.addClass('active');
                      $content.css({
                        zIndex: 200,
                        position: 'absolute'
                      });

                      // set the currently open directive to this $scope
                      utePopoverFactory.pushCurrentPopover($scope);

                    }

                  };

                  /**
                   * hides the tooltip
                   */
                  $scope.hide = function () {

                    if (!disabled) {

                      showToggle = false;
                      $content.removeClass('active');
                      if (popoverRemoveSelf) {
                        $content.remove();
                      }

                      if(angular.isDefined($scope.popoverIcon)){
                        var infoClass = '.' + $scope.popoverIcon;
                        if($document.find(infoClass)){
                          $document.find(infoClass).html('<img src="/html-fido/cms/ute/fido/images/brand/fido/info-icon.png" alt="info-tool-tip"/>');
                        }
                      }

                      $backDrop = $backDrop || $document.find('#backdrop');
                      $backDrop.removeClass('active');

                      $element.off('click');

                      $timeout(function () {
                        $element.one('click', $scope.show);
                      }, 0);

                      if ($target) {
                        $target.css({
                          zIndex: 0
                        });
                      }

                      if ($content) {
                        $content.css({
                          zIndex: 0
                        });
                      }

                      utePopoverFactory.popCurrentPopover($scope);

                    }

                  };

                  /**
                   * disable clicking to show/hide popover
                   */
                  $scope.disable = function () {
                    disabled = true;
                    $scope.hide();
                    $element.css({
                      cursor: 'auto'
                    });
                  };

                  /**
                   * enable clicking to show/hide popover
                   */
                  $scope.enable = function () {
                    disabled = false;
                    init();
                    $element.css({
                      cursor: 'pointer'
                    });
                  };

                  ///////////////////////////////
                  // private
                  ///////////////////////////////

                  var defaultOptions = {
                      placement: $scope.popoverPlacement,
                      animation: false,
                      appendToBody: false,
                      popupDelay: 0
                    },
                    placement = defaultOptions.placement,
                    isHTMLView = (/\.(html)$/i).test($scope.popoverContent),
                    viewContent = isHTMLView ?
                      '<div class=\'popover-content\' ng-include=\'popoverContent\'></div>' :
                      $scope.popoverContent,
                    tipHTML = '<div class="popover" ng-class="{ in: isOpen(), fade: animation() }">\n' +
                      '<div class="popover-inner">\n' +
                      '<h3 class="popover-title" ng-bind="title" ng-show="title"></h3>\n' +
                      viewContent +
                      '</div>\n' +
                      '</div>\n' +
                      '</div>\n' +
                      '',
                    backDrop = '<div id="backdrop" class="backdrop ute-backdrop" style="background-color:transparent;"></div>',
                    linkFn = $compile(tipHTML),
                    $content = $(linkFn($scope)),
                    showToggle = false,
                    popoverRemoveSelf,
                    popoverBackdrop,
                    $backDrop,
                    firstTimeOpen = true,
                    disabled = false,
                    $target;

                  /**
                   * positions the popover based on position and target and content dimensions
                   * @param pPosition - position either top, bottom, left and right
                   * @param content - the content being displayed in the popover
                   * @param target - the target div where the popover will be added to
                   */
                  var positionPopover = function (pPosition, content, target) {
                    if (!content) throw new Error('utePopover --> positionPopover method --> param content is undefined');
                    if (!target) throw new Error('utePopover --> positionPopover method --> param target is undefined');
                    $scope.popoverArrowPadding = $scope.popoverArrowPadding || 10;
                    if (pPosition === 'bottom') {
                      content.css({
                        top: 0 + target.outerHeight() + $scope.popoverArrowPadding,
                        bottom: 'auto',
                        left: (target.outerWidth() / 2) - (content.outerWidth() / 2),
                        right: 'auto'
                      });
                    } else if (pPosition === 'top') {
                      content.css({
                        top: 0 - content.outerHeight() - $scope.popoverArrowPadding,
                        bottom: 'auto',
                        left: (target.outerWidth() / 2) - (content.outerWidth() / 2),
                        right: 'auto'
                      });
                    } else if (pPosition === 'left') {
                      content.css({
                        top: 0 - (content.outerHeight() / 2) + (target.outerHeight() / 2),
                        bottom: 'auto',
                        left: 'auto',
                        right: 0 + target.outerWidth() + $scope.popoverArrowPadding
                      });
                    } else if (pPosition === 'right') {
                      content.css({
                        top: 0 - (content.outerHeight() / 2) + (target.outerHeight() / 2),
                        bottom: 'auto',
                        left: 0 + target.outerWidth() + $scope.popoverArrowPadding,
                        right: 'auto'
                      });
                    } else {
                      throw new Error('utePopover: positionPopover method --> placement: is undefined');
                    }
                  };

                  /**
                   * the method in which the content will be injectedß
                   */
                  var insertPopoverContent = function () {

                    if (popoverInsertMode === 'replace') {
                      $target.html($content);
                    } else if (popoverInsertMode === 'append') {
                      $target.append($content);
                    } else if (popoverInsertMode === 'after') {
                      $target.after($content);
                    } else {
                      $target.after($content);
                      throw new Error('utePopover: unknown insert mode string: ' + popoverInsertMode + ' --> $scope.popoverInsertMode should be replace, append or after, defaulting to after method');
                    }

                  };

                  /**
                   * init entire directive
                   */
                  var init = function () {

                    if (!window.jQuery) throw new Error('utePopover error: JQuery ($) is not defined, please add JQuery source to the HTML page');

                    // so arrow displays properly
                    $content.addClass(placement);
                    $content.addClass($scope.popoverClass);

                    /**
                     * whether to remove the content from the DOM when popover closes
                     * @type {boolean}
                     */
                    popoverRemoveSelf = $scope.popoverRemoveSelf || false;

                    /**
                     * whether to display backdrop/lightbox when the popover is open
                     * @type {boolean}
                     */
                    popoverBackdrop = $scope.popoverBackdrop || true;


                    if ($scope.popoverCloseTarget) {

                      $element.one('click', $scope.show);

                    } else {

                      $element.on('click', function (e) {
                        // if the target is not what was clicked then return false, prevents children from firing click events
                        if (e.target !== this) return;
                        showToggle = !showToggle;
                        showToggle ? $scope.show() : $scope.hide();
                      });

                    }

                  };

                  init();

                }]
              };

            }]);


})();
